import(/* webpackMode: "eager", webpackExports: ["AuthSection"] */ "/app/src/app/AuthSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/page.module.css");
